define([
	"dojo/_base/declare",
	"underscore",
	"csi/config",
	"csi/def/ViewRef",
	"csi/table/AggregateFrom",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"csi/xml/Query"
], function(declare,_,config,ViewRef,AggregateFrom,ActionControllerMixin,xml,Query) {

	return declare([AggregateFrom, ActionControllerMixin], {
		_bAppliedFilters: false,
		_bWizard: false,
		_subtype: null,

		getActionView: function(/*ViewRef?*/vr) {
			// summary: return event object containing reference to popup view
			var	mcv = this.getParent();
			var	mc = this.m_cache.getNode(mcv.__Parent__);
			var	subtypes = config.getNodeSetting(mc, "ChildrenSubtypes");
			var nOptionSubtypes = 0;

			if (subtypes.length == 1) {
				this._subtype = subtypes[0];
				var optionSubtypes = config.getSubtypeSetting(this._subtype, "ChildrenSubtypes");
				nOptionSubtypes = optionSubtypes.length;
			}
			if (subtypes.length > 1 || nOptionSubtypes > 1) {
				this._bWizard = true;
				vr = new ViewRef();
				vr.m_id = "AggregateFromStylesWizard";
			}

			return this.inherited(arguments, [vr]);
		},

		/*
		 * @override
		 * Filters nodes by styletype on the product subtype
		 */
		_getFixedFilters: function() {
			var q = new Query();
			q.importQuery(this.m_action.m_fixedQuery );
			var subtype = this._subtype;
			if (this._bWizard) {
				subtype = this.m_formData.getFieldValue("Subtype");
			}

			var styletypes = xml.isValidURL(subtype) && config.getSubtypeSetting(subtype, "StyleTypes");
			var subquery = q.Or();
			_.each(styletypes, function(type) {
				subquery.RefAttr("ProductType", xml.OP_EQUALS, type);
			});
			return q.getElements();
		},


		onNextPage: function(/*csi.wizard.Widget*/wizard,
							 /*csi.wizard.Content*/currentPage,
							 /*csi.wizard.Content*/nextPage,
							 /*Boolean*/bFinish) {
			// summary: apply filter to Styles table
			if (!bFinish && !this._bAppliedFilters) {
				if (wizard.getIndexOfPage(nextPage) == 1) {
					var	view = nextPage.getView(wizard);
					this.applyActionFilters(view);
					this._bAppliedFilters = true;
				}
			}

			return this.inherited(arguments);
		},

		/**
		 * @override
		 * Adding OptionSubtype to the call
		 */
		_writeRequestParameters: function(call) {
			call.addParameter("OptionSubtype", xml.ATTR_REF, this.m_formData.getFieldValue("MerchOptionType"));
			this.inherited(arguments);
		}
	});
});